
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","fill":"#6C6C6C"}},[_c('path',{attrs:{"d":"M11.428 6.845c-1.02.749-2.408.749-3.428 0-1.02.749-2.409.749-3.429 0a2.808 2.808 0 01-3.428 0v7.441c0 .947.767 1.714 1.714 1.714h2.857V9.714c0-.315.256-.571.571-.571h3.429c.316 0 .571.256.571.571V16h2.858c.946 0 1.714-.767 1.714-1.714V6.857v-.012a2.808 2.808 0 01-3.429 0zM1.143 4.571c0 .947.767 1.715 1.714 1.715.494 0 .963-.217 1.284-.594a.59.59 0 01.86 0 1.724 1.724 0 002.568 0 .59.59 0 01.861 0 1.724 1.724 0 002.568 0 .59.59 0 01.86 0c.321.377.79.593 1.285.594.946 0 1.714-.768 1.714-1.715H1.143zM1.714 0a.571.571 0 00-.542.39L.159 3.43H4V0H1.715zM7.428 0H5.143v3.429h2.285V0zM14.828.39a.571.571 0 00-.542-.39H12v3.429h3.84L14.829.39zM10.857 0H8.571v3.429h2.286V0z"}})])])
          )
        }
      }
    